import React from 'react';
import { FormattedMessage } from 'react-intl';

import css from './BuyerFeeGraphic.module.css';

/**
 * Explains the marketplace's zero-percent buyer commission with a simple price equation.
 *
 * @component
 * @returns {JSX.Element} Buyer-fee graphic.
 */
const BuyerFeeGraphic = () => {
  return (
    <section className={css.root} aria-labelledby="buyer-fee-title">
      <div className={css.content}>
        <div className={css.intro}>
          <p className={css.eyebrow}>
            <FormattedMessage id="BuyerFeeGraphic.eyebrow" />
          </p>
          <h2 id="buyer-fee-title" className={css.title}>
            <FormattedMessage id="BuyerFeeGraphic.title" />
          </h2>
          <p className={css.description}>
            <FormattedMessage id="BuyerFeeGraphic.description" />
          </p>
        </div>

        <div className={css.feeStatement} aria-label="Zero percent buyer commission">
          <strong className={css.zeroRate}>0%</strong>
          <div className={css.feeDetails}>
            <span className={css.feeLabel}>
              <FormattedMessage id="BuyerFeeGraphic.buyerCommission" />
            </span>
            <span className={css.feeValue}>
              <FormattedMessage id="BuyerFeeGraphic.feeValue" />
            </span>
          </div>
        </div>

        <p className={css.note}>
          <FormattedMessage id="BuyerFeeGraphic.note" />
        </p>
      </div>
    </section>
  );
};

export default BuyerFeeGraphic;
